import React, { ReactElement } from "react";
import type { GetServerSidePropsContext } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import DefaultLayout from "../../components/layout/DefaultLayout";
import { Breadcrumb, Heading } from "@precomposer/ui";
import AccountSignUpForm from "../../components/account/AccountSignUpForm";
import Meta from "../../components/layout/Meta";
import { getClient } from "@precomposer/data";
import { env } from "@precomposer/env";
import { fetchStoryblokStory } from "../../lib/storyblok.util";

export default function RegisterAccountPage() {
  const { t } = useTranslation(["common", "account"]);

  return (
    <>
      <Meta title={t("account:sign-up.title")} />
      <Breadcrumb>
        <Breadcrumb.Item href={"/"}>{t("common:home.title")}</Breadcrumb.Item>
        <Breadcrumb.Item>{t("account:sign-up.title")}</Breadcrumb.Item>
      </Breadcrumb>
      <Heading className={"mb-6"}>{t("account:sign-up.headline")}</Heading>
      <p className={"mb-3"}>{t("account:sign-up.text")}</p>
      <AccountSignUpForm />
    </>
  );
}

RegisterAccountPage.getLayout = function getLayout(page: ReactElement) {
  return <DefaultLayout>{page}</DefaultLayout>;
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const locale = context.locale || env("DEFAULT_LOCALE");
  const client = getClient();

  // @todo CTPT-423 migrate to App Router
  const navigationContent = await fetchStoryblokStory(
    `${env("CMS_BASE_PATH")}`,
    locale,
    client
  );

  return {
    props: {
      navigationContent: navigationContent.story.content,
      ...(await serverSideTranslations(locale, [
        "common",
        "account",
        "search",
      ])),
    },
  };
};
